import { useState } from "react";
import { useTranslation } from "react-i18next";
import { json } from "react-router-dom";
import { getTemplateEmailPreview } from "../api/templateClient";
import { TemplateEmailPreview } from "../model/TemplateEmailPreview";
import TemplateEmailPreviewDialog from "../components/Template/TemplateEmailPreview/TemplateEmailPreviewDialog";

export function useTemplateEmailPreviewDialog(): [JSX.Element, (templateId: string, customerId: string) => void, boolean] {
    const { t } = useTranslation();
    const [templatePreview, setTemplatePreview] = useState<TemplateEmailPreview | null>(null);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [templateId, setTemplateId] = useState<string | null>(null);
    const [customerId, setCustomerId] = useState<string | null>(null);

    const loadTemplatePreview = async (templateId: string, customerId: string) => {
        setLoading(true);
        setTemplateId(templateId);
        setCustomerId(customerId);
        try {
            const data = await getTemplateEmailPreview(templateId, customerId);
            setTemplatePreview(data);
            setLoading(false);
            setOpen(true);
        } catch (error) {
            setLoading(false);
            console.error("Error loading template preview:", error);
            throw json({ message: t('templateEmailPreview.loadError') || 'Could not load template preview' }, { status: 500 });
        }
    };

    const openDialog = (templateId: string, customerId: string) => {
        loadTemplatePreview(templateId, customerId);
    };

    const handleClose = () => {
        setOpen(false);
        setTemplatePreview(null);
    };

    const dialog = (
        <TemplateEmailPreviewDialog
            open={open}
            onClose={handleClose}
            templatePreview={templatePreview}
            templateId={templateId}
            customerId={customerId}
            loading={loading}
        />
    );

    return [dialog, openDialog, loading];
}

